<form #form="ngForm">
    <app-carryover-update-card
        (onChange)="updateTimeOffPolicy()"
        [timeOffPolicy]="timeOffPolicy"
    ></app-carryover-update-card>
    <app-maximum-accrued-balance-update-card [timeOffPolicy]="timeOffPolicy"></app-maximum-accrued-balance-update-card>
</form>
